import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

function EditarComite(props) {
	const { comiteOriginal, guardar, setQueMostrar } = props

	const [datosComite, setDatosComite] = useState({})

	useEffect(() => {
		setDatosComite({
			id: comiteOriginal.id,
			nombre: comiteOriginal.nombre,
			contenido: comiteOriginal.contenido,
			orden: comiteOriginal.orden
		})

	}, [comiteOriginal])

	const handleClose = () => {
		setQueMostrar('')
		setDatosComite({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datosComite,
		}

		guardar(data)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datosComite }
		datosCopia[key] = value
		setDatosComite(prev => datosCopia)
	}

	const handleSeleccionImagen = (files) => {
		setDatosComite({ ...datosComite, imagen: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar comité" />
			<Offcanvas.Body>
				<h1>Datos del comité</h1>
				{datosComite.id && (
					<Row>
						<Col sm={12} md={6}>
							<Form onSubmit={handleProcesar} className="ms-4">
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="comite-nombre">
											<FormLabel>Nombre</FormLabel>
											<Form.Control
												value={datosComite.nombre}
												type="text"
												onChange={(e) => handleChange(e.target.value, 'nombre')}
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="comite-contenido">
											<Form.Label>Contenido</Form.Label>
											<Form.Control
												as="textarea" rows={5}
												value={datosComite.contenido}
												onChange={(e) => handleChange(e.target.value, 'contenido')}
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3 col-md-3" controlId="comite-orden">
											<FormLabel>Orden</FormLabel>
											<Form.Control
												value={datosComite.orden}
												type="number"
												onChange={(e) => handleChange(e.target.value, 'orden')}
											/>
										</Form.Group>
									</Col>
								</Row>
							</Form>
						</Col>
						<Col sm={12} md={6}>
							{comiteOriginal.multimedia && (
								<div className="text-center logo-actual">
									<h4>Imagen seleccionada</h4>
									<img src={process.env.REACT_APP_API_URL + 'uploads/' + comiteOriginal.multimedia.url} alt="Imagen"/>
									<hr className="mb-5" />
								</div>
							)}

							<FileUpload
								title="Cambiar imagen"
								accept=".png, .jpg, .jpeg"
								buttonText="Elegir"
								buttonTextSingular="imagen"
								updateFiles={handleSeleccionImagen}
							/>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarComite